import { Link } from "react-router-dom";
import StatusBadge from "@/components/base/StatusBadge";

type EventCardEvent = {
  id: string;
  title: string;
  category: string;
  status: string;
  date: string;
  platform: string;
  room: string;
  reports: number;
  views: number;
  summary: string;
  cover: string;
  tags: string[];
};

type EventCardProps = {
  event: EventCardEvent;
};

export default function EventCard({ event }: EventCardProps) {
  return (
    <article className="group h-full flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-colors hover:border-primary-300">
      <Link
        to={`/events/${event.id}`}
        className="relative block w-full h-48 md:h-52 overflow-hidden shrink-0"
        aria-label={event.title}
      >
        <img
          src={event.cover}
          alt={`${event.title} 事件配图`}
          title={`${event.title} - 直播争议事件`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-foreground-950/80 text-background-50 text-xs font-medium">
          <i className="ri-price-tag-3-line" aria-hidden="true"></i>
          {event.category}
        </span>
      </Link>

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2">
          <StatusBadge status={event.status} />
          <span className="text-xs text-foreground-500">{event.date} 立案</span>
        </div>

        <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
          <Link to={`/events/${event.id}`} className="hover:text-primary-600 transition-colors">
            {event.title}
          </Link>
        </h3>

        <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{event.summary}</p>

        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1.5 min-w-0">
            <i className="ri-live-line shrink-0" aria-hidden="true"></i>
            <span className="truncate">{event.platform}</span>
          </span>
          <span className="inline-flex items-center gap-3 shrink-0">
            <span className="inline-flex items-center gap-1">
              <i className="ri-flag-2-line" aria-hidden="true"></i>
              {event.reports} 条
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden="true"></i>
              {event.views}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}